export default __webpack_public_path__ + "4c9c058d1f797c572d4fc4f7715b4248.jpg";